import { render, staticRenderFns } from "./SidebarNavTitle.vue?vue&type=template&id=339ffaf5&scoped=true"
import script from "./SidebarNavTitle.ts?vue&type=script&lang=js&external"
export * from "./SidebarNavTitle.ts?vue&type=script&lang=js&external"
import style0 from "./SidebarNavTitle.vue?vue&type=style&index=0&id=339ffaf5&prod&lang=scss&scoped=true"
import style1 from "./SidebarNavTitle.vue?vue&type=style&index=1&id=339ffaf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ffaf5",
  null
  
)

export default component.exports